import { EventMessage } from '@/common/analytics/gtm/types';
import { getOrCreateAthenaUserIdCookie } from '@/common/athena/checkAndSetAthenaCookie';
import { AthenaClickEvent } from '@/common/hooks/useAthena/athenaEvents';

import { createArtworkEventContext } from './contexts';

export const trackAthenaArtworkClick = (
  eventMessage: EventMessage,
  pushEvent: (event: AthenaClickEvent) => void,
) => {
  if (eventMessage.metadata.messageSendingDisabled) return;

  pushEvent({
    eventName: 'artworkClick',
    eventType: 'click',
    eventParams: createArtworkClickEventParams(eventMessage),
    context: createArtworkEventContext(eventMessage),
  });
};

const createArtworkClickEventParams = (eventMessage: EventMessage) => {
  const { pathname } = window.location;
  const athenaUserId = getOrCreateAthenaUserIdCookie();

  const {
    message,
    metadata: { athenaPageName, listingFunction, listingType },
  } = eventMessage;

  return {
    impressionId: `${message.index + 1}_${message.externalId}_${athenaUserId}`,
    userId: athenaUserId,
    target: `displate/${message.externalId}`,
    context: {
      itemListId: `PT:${athenaPageName}|LT:${listingType}|LF:${listingFunction}`,
      abTest: null,
      position: message.index + 1,
      source: pathname,
    },
    itemCollectionId: message.externalId,
    searchQueryId: null,
    searchPosition: null,
    itemId: message.internalId,
  };
};
